import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M2 7C2 4.23858 4.23858 2 7 2H17C19.7614 2 22 4.23858 22 7V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V7Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "DummyIconLgFill"
);
